// frontend/src/components/SEO/ProductSchema.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';
import config from '../../config';

const ProductSchema = ({ product }) => {
    if (!product) return null;

    // دریافت تصویر اصلی
    const mainImage = product.main_image ||
        (product.images && product.images.length > 0 ? product.images[0].image : null) ||
        '';

    const schema = {
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": product.name,
        "description": product.description?.substring(0, 300) || "",
        // ✅ اگر image وجود نداشت، از تصویر پیش‌فرض استفاده کن
        "image": config.getMediaUrl(mainImage || '/media/cms/logo/logo2.png'),
        "sku": `SKU-${product.id}`,
        "mpn": `MPN-${product.id}`,
        // ====== اضافه کردن برند ======
        "brand": product.brand ? {
            "@type": "Brand",
            "name": product.brand
        } : {
            "@type": "Brand",
            "name": "سان ایران"  // برند پیش‌فرض
        },
        // ====== OFFERS ======
        "offers": product.show_price_on_call ? {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "IRR",
            "availability": "https://schema.org/OutOfStock",
            "url": typeof window !== 'undefined' ? window.location.href : "",
            "description": "تماس بگیرید",
            // ✅ اضافه کردن shippingDetails (اختیاری ولی خوبه)
            "shippingDetails": {
                "@type": "OfferShippingDetails",
                "shippingRate": {
                    "@type": "MonetaryAmount",
                    "value": "0",
                    "currency": "IRR"
                },
                "deliveryTime": {
                    "@type": "ShippingDeliveryTime",
                    "handlingTime": {
                        "@type": "QuantitativeValue",
                        "minValue": 0,
                        "maxValue": 1,
                        "unitCode": "DAY"
                    }
                }
            }
        } : {
            "@type": "Offer",
            "price": String(product.discount_price || product.price),
            "priceCurrency": "IRR",
            "availability": product.stock > 0
                ? "https://schema.org/InStock"
                : "https://schema.org/OutOfStock",
            "url": typeof window !== 'undefined' ? window.location.href : "",
            // ✅ اضافه کردن shippingDetails
            "shippingDetails": {
                "@type": "OfferShippingDetails",
                "shippingRate": {
                    "@type": "MonetaryAmount",
                    "value": product.shipping_cost || "0",
                    "currency": "IRR"
                },
                "deliveryTime": {
                    "@type": "ShippingDeliveryTime",
                    "handlingTime": {
                        "@type": "QuantitativeValue",
                        "minValue": 0,
                        "maxValue": 2,
                        "unitCode": "DAY"
                    }
                }
            },
            // ✅ اضافه کردن hasMerchantReturnPolicy
            "hasMerchantReturnPolicy": {
                "@type": "MerchantReturnPolicy",
                "applicableCountry": "IR",
                "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
                "merchantReturnDays": 7,
                "returnMethod": "https://schema.org/ReturnByMail",
                "returnFees": "https://schema.org/FreeReturn"
            },
            ...(product.discount_price && {
                priceSpecification: {
                    "@type": "PriceSpecification",
                    "price": String(product.price),
                    "priceCurrency": "IRR",
                    "valueAddedTaxIncluded": "https://schema.org/True",
                }
            })
        },
        // ====== AGGREGATE RATING ======
        "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": product.rating || "4.5",
            "reviewCount": product.review_count || 10,
            "bestRating": "5",
            "worstRating": "1"
        }
    };

    // حذف فیلدهای undefined
    Object.keys(schema).forEach(key =>
        schema[key] === undefined && delete schema[key]
    );

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schema, null, 2)}
            </script>
        </Helmet>
    );
};

export default ProductSchema;
